import { Term, ApiResponse } from '@court-sync/shared';
import { apiGet, apiPost, apiPut, apiDelete, publicApiGet } from './apiClient';

export const termService = {
  async getTerms(
    academyId?: string,
    range?: { from: string; to: string }
  ): Promise<ApiResponse<Term[]>> {
    const params: Record<string, string> = {};
    if (academyId) params.academyId = academyId;
    if (range?.from && range?.to) {
      params.from = range.from;
      params.to = range.to;
    }
    return apiGet<Term[]>('/terms', { params });
  },

  async getTerm(id: string): Promise<ApiResponse<Term>> {
    return apiGet<Term>(`/terms/${id}`);
  },

  async createTerm(termData: Omit<Term, 'id' | 'createdAt' | 'updatedAt'>): Promise<ApiResponse<{ id: string }>> {
    return apiPost<{ id: string }>('/terms', termData);
  },

  async updateTerm(id: string, termData: Partial<Omit<Term, 'id' | 'createdAt' | 'updatedAt'>>): Promise<ApiResponse> {
    return apiPut(`/terms/${id}`, termData);
  },

  async deleteTerm(id: string): Promise<ApiResponse> {
    return apiDelete(`/terms/${id}`);
  },

  async getPublicTerms(academyId: string): Promise<Term[]> {
    const response = await publicApiGet<Term[]>(`/public/terms/academy/${academyId}`);
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error(response.error || 'Failed to fetch terms');
  },

  async copyLessonsFromTerm(targetTermId: string, sourceTermId: string): Promise<ApiResponse<{ copiedCount: number; errors?: string[] }>> {
    return apiPost<{ copiedCount: number; errors?: string[] }>(`/terms/${targetTermId}/copy-lessons`, { sourceTermId });
  },
};
